<template>
  <section>
    <div class="container">
      <div v-show="nezet.tipus == 'kitoltesek'">
        <div class="row">
          <div class="col-xs-12">
            <div style="padding-bottom: 30px;">
              <div class="form-title">
                Jegyzettámogatás
              </div>
              <div class="article-text">
                <div class="info-box" v-for="(idoszak, i) in idoszakok">
                  <div class="title">{{ idoszak.azonosito }}</div>
                  <div style="display: flex; flex-direction: column; align-items: flex-start;">
                    <div style="padding-bottom: 10px" v-if="(idoszak.beadott_palyazat == false && idoszak.elbiralt_palyazat == false) || (idoszak.beadott_palyazat != false && aktiv_idoszak == false && ['MENTVE'].includes(idoszak.beadott_palyazat.statusz_kulcs))">Nem található pályázat.</div>

                    <button v-if="idoszak.beadott_palyazat != false && ['VEGLEGESITVE'].includes(idoszak.beadott_palyazat.statusz_kulcs)" style="margin-top: 5px" :disabled="pdf_generalas_folyamatban" @click="pdfGeneralas(idoszak.beadott_palyazat.id)" type="button" class="button">Beadott pályázatom (Pdf)</button>
                    <button v-if="idoszak.elbiralt_palyazat != false && ['ELFOGADVA', 'ELUTASITVA'].includes(idoszak.elbiralt_palyazat.statusz_kulcs)" style="margin-top: 5px" :disabled="pdf_generalas_folyamatban" @click="pdfGeneralas(idoszak.elbiralt_palyazat.id)" type="button" class="button">Elbírált pályázatom ({{ idoszak.elbiralt_palyazat.statusz_megnevezes }}) (Pdf)</button>

                    <button v-if="aktiv_idoszak != false && aktiv_idoszak.id == idoszak.id && idoszak.beadott_palyazat == false && idoszak.elbiralt_palyazat == false" :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" @click="palyazatUrlapMegjelenites()" type="button" class="button">Új Pályázat leadása</button>
                    <button v-if="aktiv_idoszak != false && aktiv_idoszak.id == idoszak.id && idoszak.beadott_palyazat != false && idoszak.elbiralt_palyazat == false && ['MENTVE'].includes(idoszak.beadott_palyazat.statusz_kulcs)" :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" @click="palyazatUrlapMegjelenites()" type="button" class="button">Pályázat módosítása</button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'urlap'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Jegyzettámogatás
            </div>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              Amennyiben hibát talál <span class="highlight">személyes</span> vagy <span class="highlight">képzési adataiban</span>, kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.
            </div>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Személyes adatok
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="nev" name="nev" disabled label="Név" v-model="form.nev"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="neptunkod" name="neptunkod" disabled label="Neptun azonosító" v-model="form.neptunkod"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiHely" name="szuletesiHely" disabled label="Születési hely" v-model="form.szuletesiHely"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiIdo" name="szuletesiIdo" disabled label="Születési idő" v-model="form.szuletesiIdo"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="anyjaNeve" name="anyjaNeve" disabled label="Anyja neve" v-model="form.anyjaNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="telefonszam" name="telefonszam" disabled label="Telefonszám" v-model="form.telefonszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="emailCim" name="emailCim" disabled label="E-mail cím" v-model="form.emailCim"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Képzési adatok
            </h5>
          </div>
          <div class="col-xs-12">
            <comboboxV2 :errors="errors" @onChange="kepzesValt" label="Képzések" id="kepzesKodja" :options="kepzesek" v-model="form.kivalasztottKepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kar" name="kar" disabled label="Kar neve" v-model="form.kar"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="tagozat" name="tagozat" disabled label="Tagozat" v-model="form.tagozat"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesNeve" name="kepzesNeve" disabled label="Képzés" v-model="form.kepzesNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesKodja" name="kepzesKodja" disabled label="Képzés kódja" v-model="form.kepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesSzintje" name="kepzesSzintje" disabled label="Képzés szintje" v-model="form.kepzesSzintje"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="hallgatoiStatusz" name="hallgatoiStatusz" disabled label="Hallgatói státusz" v-model="form.hallgatoiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesHelye" name="kepzesHelye" disabled label="Képzés helye" v-model="form.kepzesHelye"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="penzugyiStatusz" name="penzugyiStatusz" disabled label="Pénzügyi státusz" v-model="form.penzugyiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="osztondijindex" name="osztondijindex" disabled label="Ösztöndíjindex" v-model="form.osztondijindex"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Melyik jegyzeteketre szeretnél támogatást igénybe venni?
            </h5>

            <table class="list-table list-table-stripped" v-show="form.jegyzetIdk.length > 0">
              <tr>
                <th align="left">Cikkszám</th>
                <th align="left">Megnevezés</th>
                <th align="right">Bruttó ár</th>
                <th></th>
              </tr>
              <tr :key="'jegyzet_'+i" v-for="(jegyzetId, i) in form.jegyzetIdk">
                <td>
                  {{  jegyzetAzonosito(jegyzetId) }}
                </td>
                <td>
                  {{  jegyzetMegnevezes(jegyzetId) }}
                </td>
                <td style="text-align: right">
                  {{  jegyzetBruttoAr(jegyzetId) }}
                </td>
                <td>
                  <button @click="jegyzetTorol(i)" type="button" class="button only-icon"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
              <tr class="sum">
                <td colspan="2" style="text-align: right">
                  <strong>Összesen</strong>
                </td>
                <td style="text-align: right">
                  <strong>{{ jegyzetArOsszesen }}</strong>
                </td>
                <td></td>
              </tr>
            </table>

            <div class="form-group">
              <comboboxV2 label="Jegyzet" id="hozzaadandojegyzetId" :errors="errors" :options="hozzaadhatoJegyzetek" v-model="hozzaadandojegyzetId"/>
              <button :disabled="hozzaadandojegyzetId == '0'" @click="jegyzetHozzaad" type="button" class="button only-icon">+</button>
            </div>
          </div>
          <div class="col-xs-12">
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Megjegyzés
            </h5>
          </div>
          <div class="col-xs-12">
            <textareabox :autogrow="true" maxlength="5000" label="" :errors="errors" id="megjegyzes" name="megjegyzes" v-model="form.megjegyzes"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Hallgatói nyiltakozat
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="nyilatkozatElfogadas" type="checkbox" v-model="form.nyilatkozatElfogadas"/>
                <label for="nyilatkozatElfogadas">
                  <div class="icon"></div>
                  A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozatElfogadas'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save(0)" :disabled="mentes_folyamatban" type="button" class="button">Mentés</button>
              <button v-on:click="save(1)" :disabled="mentes_folyamatban" type="button" class="button">Véglegesít</button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'info'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Jegyzettámogatás
            </div>
            <div class="article-text" v-html="nezet.tartalom"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        nev: '',
        neptunkod: '',
        szuletesiHely: '',
        szuletesiIdo: '',
        anyjaNeve: '',
        telefonszam: '',
        emailCim: '',
        kar: '',
        tagozat: '',
        kepzesNeve: '',
        kepzesSzintje: '',
        kepzesKodja: '',
        kepzesHelye: '',
        penzugyiStatusz: '',
        hallgatoiStatusz: '',
        osztondijindex: 0,
        felevekSzama: 0,
        jegyzetIdk: [],
        nyilatkozatElfogadas: 0,
        kivalasztottKepzesKodja: '',
        megjegyzes: ''
      },
      jegyzetek: [],

      kepzesek: [],
      hozzaadhatoJegyzetek: [],
      hozzaadandojegyzetId: '0',
      errors: [],
      fill_info: '',
      mentes_folyamatban: false,
      pdf_generalas_folyamatban: false,
      aktiv_idoszak: false,
      nezet: {
        tipus: 'info',
        tartalom: ''
      }
    }
  },

  computed: {
    jegyzetArOsszesen() {
      const _this = this;
      let osszesen = 0;
      this.form.jegyzetIdk.forEach(jegyzetId => {
        this.jegyzetek.map((jegyzet) => {
          if (parseInt(jegyzetId) == parseInt(jegyzet.value)) {
            osszesen += parseInt(jegyzet.bruttoAr);
          }
        });
      });
      return osszesen.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " Ft";
    }
  },

  mounted: function() {
    this.init();
  },

  methods: {
    init() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Adatok betöltése folyamatban...';

      this.$root.ajax('form/jegyzettamogatas/', {
        method: 'post',
        data: {
          query: this.$route.query
        },
        success: function(response) {
          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          _this.idoszakok = response.idoszakok;
          _this.aktiv_idoszak = response.aktiv_idoszak;
          _this.nezet.tipus = 'kitoltesek';
        }
      });
    },

    saveConfirm: function(veglegesit) {
      const _this = this;

      swal({
        title: "Biztos véglegesíti a pályázatot?",
        text: "A pályázat véglegesítés után változtatni már nem lehetséges!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.save(veglegesit);
        }
      });
    },

    palyazatUrlapMegjelenites() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Űrlap betöltése folyamatban...';

      this.$root.ajax('form/jegyzettamogatas_urlap/', {
        method: 'post',
        data: {
          query: this.$route.query
        },
        success: function(response) {
          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          if (response.veglegesitve) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltés véglegesítve.';
            return;
          }

          if (response.kepzesek != undefined) {
            _this.kepzesek = response.kepzesek;
            _this.form.kivalasztottKepzesKodja = _this.kepzesek[0].value;
            _this.kepzesValt();
          }

          if (response.jegyzetek != undefined) {
            _this.jegyzetek = [{value: '0', label: '- válassz jegyzetet -'}, ...response.jegyzetek];
          }

          if (response.form != undefined) {
            _this.form = response.form;
            _this.form.kivalasztottKepzesKodja = response.form.kepzesKodja;
          }

          _this.hozzaAdhatoJegyzetek();

          _this.nezet.tipus = 'urlap';
        }
      });
    },

    save: function(veglegesit) {
      const _this = this;
      this.errors = [];

      this.mentes_folyamatban = true;

      this.$root.ajax('form/jegyzettamogatas_ment/', {
        method: 'post',
        data: {
          form: this.form,
          veglegesit: veglegesit,
          query: this.$route.query
        },
        success: function(response) {
          _this.mentes_folyamatban = false;

          if (response.exception_error != false) {
            swal('Hiba', response.exception_error, 'error');
            return;
          }

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;
            swal('Adatbeviteli hiba', 'Kérjük ellenőrizze az űrlapot.', 'error');
            return;
          }

          if (veglegesit == 0) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltése mentve.';
          }

          if (veglegesit == 1) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltés véglegesítve.';
          }
        }
      });
    },

    kepzesValt() {
      const _this = this;

      this.kepzesek.map((kepzes) => {
        if (kepzes.kepzesKodja == _this.form.kivalasztottKepzesKodja) {
          _this.form.kar = kepzes.kar;
          _this.form.tagozat = kepzes.tagozat;
          _this.form.kepzesNeve = kepzes.kepzesNeve;
          _this.form.kepzesSzintje = kepzes.kepzesSzintje;
          _this.form.kepzesKodja = kepzes.kepzesKodja;
          _this.form.kepzesHelye = kepzes.kepzesHelye;
          _this.form.penzugyiStatusz = kepzes.penzugyiStatusz;
          _this.form.hallgatoiStatusz = kepzes.hallgatoiStatusz;
          _this.form.osztondijindex = kepzes.osztondijindex == null ? 0 : kepzes.osztondijindex;
          _this.form.nev = kepzes.nev;
          _this.form.neptunkod = kepzes.neptunkod;
          _this.form.szuletesiHely = kepzes.szuletesiHely;
          _this.form.szuletesiIdo = kepzes.szuletesiIdo;
          _this.form.anyjaNeve = kepzes.anyjaNeve;
          _this.form.telefonszam = kepzes.telefonszam == null ? '' : kepzes.telefonszam;
          _this.form.emailCim = kepzes.emailCim == null ? '' : kepzes.emailCim;
        }
      });
    },

    jegyzetHozzaad() {
      this.form.jegyzetIdk.push(this.hozzaadandojegyzetId);
      this.hozzaAdhatoJegyzetek();
    },

    jegyzetTorol(index) {
      this.form.jegyzetIdk.splice(index, 1);
      this.hozzaAdhatoJegyzetek();
    },

    jegyzetAzonosito(id) {
      let azonosito = '';

      this.jegyzetek.map((jegyzet) => {
        if (parseInt(id) == parseInt(jegyzet.value)) {
          azonosito = jegyzet.azonosito;
        }
      });

      return azonosito;
    },

    jegyzetMegnevezes(id) {
      let megnevezes = '';

      this.jegyzetek.map((jegyzet) => {
        if (parseInt(id) == parseInt(jegyzet.value)) {
          megnevezes = jegyzet.megnevezes;
        }
      });

      return megnevezes;
    },

    jegyzetBruttoAr(id) {
      let bruttoAr = '';

      this.jegyzetek.map((jegyzet) => {
        if (parseInt(id) == parseInt(jegyzet.value)) {
          bruttoAr = jegyzet.bruttoArFormazott;
        }
      });

      return bruttoAr;
    },

    hozzaAdhatoJegyzetek() {
      const _this = this;

      this.hozzaadhatoJegyzetek = [];

      this.jegyzetek.map((jegyzet) => {
        if (!_this.form.jegyzetIdk.includes(jegyzet.value)) {
          _this.hozzaadhatoJegyzetek.push(jegyzet);
        }
      });

      this.hozzaadandojegyzetId = '0';
    },

    pdfGeneralas(id) {
      const _this = this;

      this.pdf_generalas_folyamatban = true;

      this.$root.ajax('form/jegyzettamogatas_pdf_gen/', {
        method: 'post',
        data: {
          id: id,
          query: this.$route.query
        },
        success: function(response) {
          _this.pdf_generalas_folyamatban = false;

          if (response.exception_error != false) {
            swal('Hiba', response.exception_error, 'error');
            return;
          }

          if (response.pdf_fajl != undefined) {
            window.open(location.protocol + '//' + location.host + '/assets/urlap_kitoltesek/' + response.pdf_fajl);
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// jegyzettamogatas.vue?6135df04